import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import "./CommunityLists.css"; // Main CSS for Community Lists
import CommunityHeader from "../../components/Community/CommunityHeader"; // Header component
import CommunityProfileDescription from "../../components/Community/Communityprofiledescription"; // Profile Description component
import CommunityTabsRoom from "../../components/Community/Communitytabsroom"; // Tabs Component

const socket = io("http://localhost:5000");

const CommunityLists = () => {
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState("");
  const [messageInput, setMessageInput] = useState("");

  useEffect(() => {
    socket.on("message", (msg) => {
      setMessages((prev) => [...prev, msg]);
    });

    socket.on("typing", (user) => {
      setTyping(`${user} is typing...`);
      setTimeout(() => setTyping(""), 3000);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      socket.emit("send_message", { user: "You", text: messageInput });
      setMessages((prev) => [...prev, { user: "You", text: messageInput }]);
      setMessageInput("");
    }
  };

  return (
    <div className="CommunityLists-container">
      <div className="CommunityLists">
        {/* Top Section */}
        <CommunityHeader roomTitle="JOHN HOSTING" roomName="ROOM NAME: LISTS" />

        {/* Profile Details Section */}
        <CommunityProfileDescription
          userName="JOHN HOSTING"
          description="Manage all your lists in this section. Customize and organize your content easily."
          avatarSrc="john-prof-pic-07.png"
        />

        {/* Tabs Section */}
        <CommunityTabsRoom />

        {/* Messages Section */}
        <div className="CommunityLists-chat">
          {messages.map((msg, index) => (
            <div key={index} className="CommunityLists-message">
              <p>
                <strong>{msg.user}: </strong>
                {msg.text}
              </p>
            </div>
          ))}
          <p className="CommunityLists-typing">{typing}</p>
          <div className="CommunityLists-input">
            <input
              type="text"
              value={messageInput}
              onChange={(e) => setMessageInput(e.target.value)}
              placeholder="Type your message"
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityLists;
